<template>
  <div class="row">
    <div class="col-4 border-bottom border-left py-2">
      <span
        v-if="mode !== 'edit'"
        :title="field.level"
        :class="`mr-2 rounded-circle align-middle questionnaire-dot questionnaire-dot-${strength}`">
      </span>

      {{field.label}}
    </div>

    <div class="col-4 border-bottom border-left py-2">
      <div v-if="userCanEdit && mode === 'edit'">
        <div v-if="field.type === 'checkbox'" class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            v-model="value"
            @change="editAnswer" />
          <label class="form-check-label">&nbsp;</label>
        </div>

        <div v-else-if="field.type === 'textarea'">
            <textarea
              class="form-control"
              v-model="value"
              @change="editAnswer"></textarea>
        </div>

        <div v-else>
          <input
            type="text"
            class="form-control"
            v-model="value"
            @change="editAnswer" />
        </div>
      </div>

      <div v-else-if="typeof field.answer !== 'undefined'">
        <div v-if="field.type !== 'checkbox'">
          {{field.answer.value}}
        </div>
      </div>
    </div>
    <div
      class="col-4 border-bottom border-left py-2"
      @click="addComment">
      <div v-if="userCanEdit && mode === 'edit'">
        <textarea
          v-model="comment"
          class="form-control"
          @change="editAnswer">
        </textarea>
      </div>

      <div v-else-if="sending" class="text-primary">
        Loading...
      </div>

      <div v-else-if="userCanComment && commenting">
        <textarea
          v-model="comment"
          class="form-control"
          @change="sendComment">
        </textarea>
      </div>

      <div v-else-if="typeof field.answer !== 'undefined'">
        {{field.answer.comment}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireField',

  props: ['field', 'mode', 'commentAnswer', 'updateAnswer', 'userCanEdit', 'userCanComment'],

  data() {
    return {
      strength: 0,
      sending: false,
      commenting: false,
      comment: '',
      value: '',
    };
  },

  created() {
    this.strength = [80, 60, 40, 20, 0].find(l => l <= this.field.level) || 0;

    if (typeof this.field.answer !== 'undefined') {
      this.comment = this.field.answer.comment;
      this.value = this.field.answer.value;
    }
  },

  methods: {
    addComment () {
      if (this.sending || this.commenting || this.mode === 'edit') {
        return;
      }

      this.commenting = true;
    },

    async sendComment() {
      this.sending = true;

      try {
        await this.commentAnswer(this.field.answer.id, this.comment);

        this.commenting = false;
      } catch (e) {
        //do nothing
      }

      this.sending = false;
    },

    editAnswer() {
      const { type } = this.field;
      const { value, comment } = this;

      if (type === 'checkbox' && (value === null || value === false)) {
        return this.updateAnswer(this.field.id, null);
      }

      if (['textarea', 'text'].includes(type) && value.trim() === '') {
        return this.updateAnswer(this.field.id, null);
      }

      this.updateAnswer(this.field.id, { value, comment });
    },
  },
};
</script>
